<template>
  <div class="uniform-check">
    <h3>智能检测结果</h3>

    <header>
      <el-steps :active="curStep" align-center simple finish-status="success">
        <el-step title="低错检查"></el-step>
        <el-step title="术语检查"></el-step>
        <el-step v-if="isMainQc">
          <div class="step-title" slot="title">
            <p>高频词</p>
            <p>一致性检查</p>
          </div>
        </el-step>
        <el-step v-if="flowCount > 3">
          <div class="step-title" slot="title">
            <p>高相似句</p>
            <p>一致性检查</p>
          </div>
        </el-step>
        <el-step v-if="flowCount > 4">
          <div class="step-title" slot="title">
            <p>关键位置句子</p>
            <p>一致性检查</p>
          </div>
        </el-step>
      </el-steps>
    </header>

    <section v-loading="loading" element-loading-text="智能检测中，请稍后">
      <low-error
        v-if="curStep === STEP.one && !loading"
        :query-params="queryParams"
        :isMainQc="isMainQc"
        :qcTaskIdDic="qcTaskIdDic"
        @next="next"
      />
      <unused-term
        v-if="curStep === STEP.two && !loading"
        :query-params="queryParams"
        :isMainQc="isMainQc"
        :qcTaskIdDic="qcTaskIdDic"
        @next="isMainQc ? next() : submit()"
      />
      <messy-high-term
        v-if="curStep === STEP.three && !loading"
        :query-params="queryParams"
        :flowCount="flowCount"
        @next="flowCount > 3 ? next() : submit()"
      />
      <HighSimilar
        v-if="curStep === STEP.four && !loading"
        :query-params="queryParams"
        :flowCount="flowCount"
        @next="flowCount > 4 ? next() : submit()"
      />
      <Critical
        v-if="curStep === STEP.five && !loading"
        :query-params="queryParams"
        :flowCount="flowCount"
        @next="flowCount > 5 ? next() : submit()"
      />
    </section>
  </div>
</template>

<script>
import {
  setUniformCheckStep,
  getUniformCheckStatus,
  submitUniformCheck,
} from '@/api/qc/qcflow';
import { qcList } from '@/api/dot/qc';
import { pollFetch } from '@/util/http';
import LowError from './low-error.vue';
import UnusedTerm from './unused-term.vue';
import MessyHighTerm from './messy-high-term.vue';
import HighSimilar from './high-similar.vue';
import Critical from './critical.vue';
import { FLOW_STATUS, STEP } from './const';
import { mapState } from 'vuex';
import './index.scss';

export default {
  components: { LowError, UnusedTerm, MessyHighTerm, HighSimilar, Critical },
  data() {
    return {
      STEP,
      curStep: STEP.none,
      loading: true,
      // 默认在起始状态：等待调度完成
      flowStatus: FLOW_STATUS.waitDispatch,
      queryParams: {},
      isMainQc: false,
      qcTaskIdDic: [],
      // 总步骤数
      flowCount: 0,
    };
  },
  created() {
    // init params
    this.queryParams = {
      ...this.$route.params,
      ...this.$route.query,
    };

    this.pollFetchStatus();
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
  },
  methods: {
    getQcList() {
      qcList({
        orderId: this.queryParams.id,
        taskType: this.isMainQc ? 1 : 2,
        qcId: this.userInfo.staffId,
      }).then((res) => {
        let data = res?.data?.data;
        this.qcTaskIdDic = data?.map((it) => {
          return {
            label:
              (it.taskType == 1 ? '主' : '子') +
              it.id.substr(it.id.length - 6, it.id.length) +
              ' ' +
              it.qcId,
            value: it.id,
          };
        });
      });
    },

    pollFetchStatus() {
      this.loading = true;
      // 轮询查询当前状态
      pollFetch(
        getUniformCheckStatus.bind(null, {
          orderId: this.queryParams.id,
          qcTaskId: this.queryParams.taskId,
        }),
        // 接口返回
        (res) => {
          const useableData = res.data?.data ?? {};
          // 兼容el-step组件：起始步骤是0
          this.curStep = useableData.currentFlow - 1;
          this.isMainQc = useableData.isMain === '1';
          this.flowCount = useableData.flowCount ?? 5;
          if (this.isMainQc) {
            this.getQcList();
          }
          // 判断步骤是否完成
          if (useableData.flowStatus !== FLOW_STATUS.waitDispatch) {
            // 结束轮询
            this.loading = false;
            return true;
          }
          return false;
        },
      );
    },
    // 低错 + 术语检查的下一步
    next() {
      if (this.loading) return;
      setUniformCheckStep({
        orderId: this.queryParams.id,
        currentFlow: this.curStep + 1,
        qcTaskId: this.queryParams.taskId,
      })
        .then(() => {
          this.pollFetchStatus();
        })
        .catch((err) => {
          if (err.message === '该质控任务状态已修改') {
            this.$closeAndGoBack();
          }
        });
    },
    submit() {
      submitUniformCheck({
        orderId: this.queryParams.id,
        qcTaskId: this.queryParams.taskId,
      })
        .then(() => {
          this.$message({
            message: '提交成功',
            type: 'success',
          });
          this.$closeAndGoBack();
        })
        .catch((err) => {
          if (err.message === '该质控任务状态已修改') {
            this.$closeAndGoBack();
          }
        });
    },
  },
  beforeDestroy() {
    pollFetch.clearTimer();
  },
};
</script>
